var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 4.25008V3.68342C10.3333 2.89001 10.3333 2.4933 10.1789 2.19026C10.0431 1.9237 9.82638 1.70698 9.55982 1.57116C9.25678 1.41675 8.86007 1.41675 8.06667 1.41675H6.93333C6.13993 1.41675 5.74322 1.41675 5.44018 1.57116C5.17362 1.70698 4.95689 1.9237 4.82107 2.19026C4.66667 2.4933 4.66667 2.89001 4.66667 3.68342V4.25008M6.08333 8.14592V11.6876M8.91667 8.14592V11.6876M1.125 4.25008H13.875M12.4583 4.25008V12.1834C12.4583 13.3735 12.4583 13.9686 12.2267 14.4231C12.023 14.823 11.6979 15.1481 11.2981 15.3518C10.8435 15.5834 10.2484 15.5834 9.05833 15.5834H5.94167C4.75156 15.5834 4.1565 15.5834 3.70194 15.3518C3.30209 15.1481 2.97701 14.823 2.77328 14.4231C2.54167 13.9686 2.54167 13.3735 2.54167 12.1834V4.25008",
    stroke: "#FF0000",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/trashcan.bcc7af83a4f35965d00c33b7392131c6.svg";
export { ForwardRef as ReactComponent };